import React from 'react'
import Manager from '../../public/components/Manager'
import SupplierDiv from './SupplierDiv'
import SupplierKindClassDiv from './SupplierKindClassDiv'
import SupplierKindItemDiv from './SupplierKindItemDiv'
Ext.require('Ext.Toast')

const config = ({ roles }) => {
    return {
        tabs: {
            '合格供应商': {
                export: roles.indexOf('总经理_工程') > -1 || roles.indexOf('权限管理员') > -1,
                buttons: [
                    // { text: '导入...', btnName: '提交', handler: ({ refreshPage }) => Tyan.pubForm.showImport('ImportSupplier', '供应商导入', (data) => refreshPage && refreshPage()) },
                ],
                columns: [
                    { _text: '供应商编号', field: 'Number', search: true, minWidth: 150/* , tools: tipTools */ },
                    { _text: '供应商名称', field: 'SupplierName', search: true, minWidth: 150, flex: 1, },
                    { _float: '成交总额', field: 'PurchasingAmout', minWidth: 150 },
                    { _text: '公司地址', field: 'Address', search: true, minWidth: 150, },
                    { _date: '公司成立日期', field: 'IncorporationDate', minWidth: 150 },
                    { _text: '公司负责人', field: 'CompanyHead', search: true, minWidth: 150, },
                    { _text: '公司电话', field: 'CompanyTel', minWidth: 150, search: true, },
                    { _text: '评定等级', field: 'Score', minWidth: 150, },
                    { _: '曾用名', search: true, }
                ],
                onDoubleTap: ({ showDetail }, data) => showDetail(props => <SupplierDiv {...props} id={data.id} readOnly={true} roles={roles} />),
                categories: {
                    onDoubleTap: (that, data, record, grid) => { },
                    width: '330',
                    contextmenu: [
                        {
                            _button: '添加分类方式', icon: 'plus',
                            hidden: data => data.type !== '全部',
                            handler: (that, data, record, grid) => {
                                Tyan.pubForm.showDialog('供应商分类方式', props => <SupplierKindClassDiv {...props} id={0} onSave={that.refresh} />)
                            },
                        },
                        {
                            _button: '添加分类', icon: 'plus',
                            hidden: data => data.depth !== 2,
                            handler: (that, data, record, grid) => {
                                Tyan.pubForm.showDialog('供应商分类', props => <SupplierKindItemDiv {...props} classID={data.id} id={0} onSave={that.refresh} />)
                            },
                        },
                        {
                            _button: '属性', icon: 'info',
                            hidden: data => data.type !== '分类方式',
                            handler: (that, data, record, grid) => {
                                Tyan.pubForm.showDialog('供应商分类方式', props => <SupplierKindClassDiv {...props} depth={data.depth} id={data.id} onSave={that.refresh} />)
                            },
                        },
                        {
                            _button: '属性', icon: 'info',
                            hidden: data => data.type !== '分类',
                            handler: (that, data, record, grid) => {
                                Tyan.pubForm.showDialog('供应商分类', props => <SupplierKindItemDiv {...props} id={data.id} onSave={that.refresh} />)
                            },
                        },
                    ],
                },
            },
            '不合格供应商': {
                buttons: [
                ],
                columns: [
                    { _text: '供应商编号', field: 'Number', search: true, minWidth: 150/* , tools: tipTools */ },
                    { _text: '供应商名称', field: 'SupplierName', search: true, minWidth: 150, flex: 1, },
                    { _float: '成交总额', field: 'PurchasingAmout', minWidth: 150 },
                    { _text: '公司地址', field: 'Address', search: true, minWidth: 150, },
                    { _date: '公司成立日期', field: 'IncorporationDate', minWidth: 150 },
                    { _text: '公司负责人', field: 'CompanyHead', search: true, minWidth: 150, },
                    { _text: '公司电话', field: 'CompanyTel', minWidth: 150, search: true, },
                    { _text: '评定等级', field: 'Score', minWidth: 150, },
                    { _: '曾用名', search: true, }
                ],
                onDoubleTap: ({ showDetail }, data) => showDetail(props => <SupplierDiv {...props} id={data.id} readOnly={true} roles={roles} />),
                categories: {
                    onDoubleTap: (that, data, record, grid) => { },
                    width: '330',
                    contextmenu: [
                        {
                            _button: '添加分类方式', icon: 'plus',
                            hidden: data => data.type !== '全部',
                            handler: (that, data, record, grid) => {
                                Tyan.pubForm.showDialog('供应商分类方式', props => <SupplierKindClassDiv {...props} id={0} onSave={that.refresh} />)
                            },
                        },
                        {
                            _button: '添加分类', icon: 'plus',
                            hidden: data => data.depth !== 2,
                            handler: (that, data, record, grid) => {
                                Tyan.pubForm.showDialog('供应商分类', props => <SupplierKindItemDiv {...props} classID={data.id} id={0} onSave={that.refresh} />)
                            },
                        },
                        {
                            _button: '属性', icon: 'info',
                            hidden: data => data.type !== '分类方式',
                            handler: (that, data, record, grid) => {
                                Tyan.pubForm.showDialog('供应商分类方式', props => <SupplierKindClassDiv {...props} depth={data.depth} id={data.id} onSave={that.refresh} />)
                            },
                        },
                        {
                            _button: '属性', icon: 'info',
                            hidden: data => data.type !== '分类',
                            handler: (that, data, record, grid) => {
                                Tyan.pubForm.showDialog('供应商分类', props => <SupplierKindItemDiv {...props} id={data.id} onSave={that.refresh} />)
                            },
                        },
                    ],
                },
            }
        }
    }
}

export default props => <Manager {...props} config={config} />